import React from "react";
import { Container } from "react-bootstrap";
import Products from "./Products";
import { stringConstants } from "../../../helpers/app-constants";
import Brands from "./Brands";
// import BasicInformation from "../common/BasicInformation";
import Address from "../common/Address";
import FactoryInfo from "./FactoryInfo";
import BankingAndTaxation from "../common/BankingAndTaxation";
import Dashbord from "./Dashbord";
import Companyinformation from "./CompanyInfo";
import Variants from "./Variants";
import LogisticPartner from "../common/LogisticPartner";
import AcceptedOrders from "./AcceptedOrders";
import AcceptedEnquiries from "./AcceptedEnquiries";
import LiveOffers from "./LiveOffers";
import Calculations from "./Calculations";
import { Row } from "react-bootstrap";
import Subscriptions from "./Subscriptions";
import Invoices from "./Invoices";
import UserDetails from "../AdminPanelBharee/UsersList/UserDetails";
import SalesReport from "./Reports/SalesReport";
import EnquiryReport from "./Reports/EnquiryReport";
import ReferralForm from "./ReferralForm";
import ReferralHistory from "./ReferralHistory";

const AdminPanelSeller = ({
  currentView,
  notificationOrderId,
  notificationEnquiryId,
  currentViewId,
  currentViewObj,
}) => {
  switch (currentView) {
  case stringConstants.DASHBOAD:
  return (
    <Dashbord
      notificationOrderId={notificationOrderId}
      notificationEnquiryId={notificationEnquiryId}
    />
  );

case stringConstants.REFERRAL:
  return <ReferralForm />;

  case stringConstants.REFERRAL_HISTORY:
  return <ReferralHistory />;
  
case stringConstants.REPORTS:
  return (
    <Container className="py-5 px-2">
      {"Report will appear and also download or export reports will be here"}
    </Container>
  );
    case stringConstants.SALES_REPORT:
      return <SalesReport />;
    case stringConstants.ENQUIRY_REPORT:
      return <EnquiryReport />;
    case stringConstants.MY_INVOICES:
      return <Invoices />;
    case stringConstants.MY_SUBSCRIPTIONS:
      return <Subscriptions />;
    case stringConstants.LIVE_OFFERS:
      return <LiveOffers mainClass="section-row" />;
    case stringConstants.COST_CALCULATIONS:
      return (
        <Container className="px-2">
          <Row className="section-row ">
            <Calculations />
          </Row>
        </Container>
      );
    case stringConstants.MY_ENQUIRIES:
      return <AcceptedEnquiries enquiryStatus={"accepted"} title={"Accepted Enquiries"} />;
    case stringConstants.MY_ORDERS:
      return (
        <div className="mt-4">
          <div className="mb-4">
            <AcceptedOrders orderStatus={"accepted"} title={"Accepted Orders"} />
          </div>
          <div className="mb-4">
            <AcceptedOrders
              orderStatus={"shipped"}
              title={"Orders Assigned to LP & Not Accepted"}
            />
          </div>
          <div className="mb-4">
            <AcceptedOrders orderStatus={"lpaccepted"} title={"LP Accepted Orders"} />
          </div>
          <div className="mb-4">
            <AcceptedOrders orderStatus={"outfordelivery"} title={"Out for Delivery Orders"} />
          </div>
          <div className="mb-4">
            <AcceptedOrders orderStatus={"delivered"} title={"Delivered Orders"} />
          </div>
          <div className="mb-4">
            <AcceptedOrders orderStatus={"cancelled"} title={"Cancelled Orders"} />
          </div>
          <div className="mb-4">
            <AcceptedOrders orderStatus={"rejected"} title={"Rejected Orders"} />
          </div>
        </div>
      );
    case stringConstants.PRODUCTS:
      return <Products />;
    case stringConstants.VARIANTS:
      return <Variants />;
    case stringConstants.BRANDS:
      return <Brands />;
    case stringConstants.LOGISTIC_PARTNER:
      return (
        <LogisticPartner
          fromSubscriptionUpgrade={currentViewObj?.fromSubscriptionUpgrade ? true : false}
        />
      );
    case stringConstants.COMPANY_INFORMATION:
      return <Companyinformation />;
    case stringConstants.ADDRESS:
      return <Address />;
    case stringConstants.FACTORY_INFO:
      return <FactoryInfo />;
    case stringConstants.BANKING_AND_TAXATION:
      return <BankingAndTaxation />;
    case stringConstants.USER_DETAILS:
      return <UserDetails userId={currentViewId} userObj={currentViewObj} />;
    default:
      return <Container>{"work in process.."}</Container>;
  }
};

export default AdminPanelSeller;
